import { BasicInformation } from "./components/saleOperations/BasicInformation";
// import { CreateOperation } from "./components/saleOperations/CreateOperation";

export const CabotageForm = () => {
  return (
    <div>
      <BasicInformation operationType="cabotage" />
      {/* <CreateOperation /> */}
    </div>
  );
};
